<template>
  <div class="StepCycleTime mainWrap" v-loading.fullscreen.lock="fullscreenLoading">
    <el-container style="height:100%; background-color:rgba(0, 0, 0, 0);">
      <!-- 左边导航栏 -->
      <el-aside style="width:auto;">
        <leftNav msg="/ES001"></leftNav>
      </el-aside>
      <!-- 右侧主体部分 -->
      <el-container>
        <!-- 页面部分 -->
        <el-scrollbar class="machineWrap" style="height:100%;width:100%;">
          <el-main>
            <div class="mainWrao">
              <div class="recordTitle">
                <h1>{{$t('leftNav.navFour')}}</h1>
                <div style="float:right;display:flex;align-items: center;">
                  <label style="margin-right:10px;font-size:12px;">{{$t('StepCycleTime.labelTitle1')}}</label>
                  <equipment @change="getchange" class="machinevue" :machine="machineID[1]"></equipment>
                </div>
              </div>
              <!-- 柱状图 -->
              <div class="seach">
                <!-- <el-date-picker
                  class="dataWrap"
                  @change="clearDis"
                  v-model="$store.state.datePicker"
                  type="datetimerange"
                  range-separator="——"
                  :picker-options="pickerOptions"
                  format='yyyy-MM-dd HH:mm'
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :start-placeholder="$t('StepCycleTime.StartTime')"
                  :end-placeholder="$t('StepCycleTime.EndTime')">
                </el-date-picker> -->
                <!-- 新日期选择 -->
                <el-date-picker
                  @focus='getfocus(1)'
                  class="dataWrap1"
                  ref="dataWrap1"
                  :clearable='false'
                  @change="clearDis"
                  v-model="$store.state.startPicker"
                  type="datetime"
                  :picker-options="pickerOptions"
                  format='yyyy-MM-dd HH:mm'
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="$t('StepCycleTime.StartTime')">
                </el-date-picker>
                <!-- <p class="tips leftTips" v-if="tipsOne">{{$t('StepCycleTime.error8')}}</p> -->
                <span>—</span>
                <el-date-picker
                  @focus='getfocus(2)'
                  class="dataWrap2"
                  ref="dataWrap2"
                  @change="clearDis"
                  :clearable='false'
                  v-model="$store.state.endPicker"
                  type="datetime"
                  :picker-options="pickerOptions"
                  format='yyyy-MM-dd HH:mm'
                  value-format="yyyy-MM-dd HH:mm:ss"
                  :placeholder="$t('StepCycleTime.EndTime')">
                </el-date-picker>
                <!-- <p class="tips rightTips" v-if="tipsTwo">{{$t('StepCycleTime.error8')}}</p> -->
                <label>{{$t('StepCycleTime.labelTitle2')}}</label>
                <div v-loading="$store.state.stepSelectLoading" element-loading-spinner="el-icon-loading" style="display: inline-block;">
                  <el-cascader
                    style="width:300px;"
                    :placeholder="$t('StepCycleTime.placehoder1')"
                    v-model="$store.state.selectValue"
                    :options="$store.state.selectOptions"
                    expand-trigger="hover"
                    >
                  </el-cascader>
                </div>
                <el-button @click="showBtn()" style="float:right;" type="primary" icon="el-icon-view">{{$t('StepCycleTime.showBtn')}}</el-button>
              </div>
              <!-- 柱状图 -->
              <div v-show="noData" class="noMachineTitle">{{$t('WorkShopDashBoard.noEquipmentTableMessage')}}</div>
              <div id="chartWrap" style="width:100%; margin-bottom:30px;" v-show="!noData">
                <div v-if="JSON.stringify(machineData) !== '{}'">
                  <div v-show=" $store.state.lang===0" class="chartTitle">{{machineData.machineStepMsg.code +' '+ machineData.machineStepMsg.descriptionEn +' of ' + machineData.machineInfo.nameEn}}</div>
                  <div v-show="$store.state.lang===1" class="chartTitle">{{machineData.machineInfo.equipmentName+'('+machineData.machineInfo.nameEn +')' + ' 的 ' + machineData.machineStepMsg.code +' '+ machineData.machineStepMsg.description }}</div>
                  <p class="time">{{showStartTime}} ~ {{showEndTime}}</p>
                </div>
                <div id="StepCycleTimemyChart" style="width:85%;height:700px;padding-left:20px;"></div>
              </div>
            </div>
          </el-main>
        </el-scrollbar>
      </el-container>
    </el-container>
    <!-- 弹出框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="990px"
      :close-on-click-modal = 'false'
      :close-on-press-escape = 'false'
      v-dialogDrag>
      <div slot="title" class="dialog-title">
        <p>{{$t('StepCycleTime.tableTitle')}}</p>
        <span><span style="color:black;margin-right:20px;">{{$t('StepCycleTime.tableLable1')}}</span> {{showStartTime}} ~ {{showEndTime}}</span>
      </div>
      <el-table
        :data="tableData"
        max-height="400"
        border
        style="width: 100%">
        <el-table-column
          v-for="(item,index) in shiftArr"
          :key="item"
          header-align='center'
          :label="$t('StepCycleTime.shiftTitle')+' '+ tableTitle[index]"
          >
          <template slot-scope="scope">
            <div v-if="scope.row['shift'+item] !== ''" :class="{celldis: scope.row['shift'+item].show === 'false'}">
              <span class="shiftTime">{{ scope.row['shift'+item].time }}</span>
              <div class="tireWrap">
                <span class="left" v-if="scope.row['shift'+item].searchSum !== scope.row['shift'+item].shiftSum" :title="$t('StepCycleTime.dialogTitle1')+scope.row['shift'+item].searchSum+$t('StepCycleTime.dialogTitle3')">{{scope.row['shift'+item].searchSum}}</span><span class="right" :title="$t('StepCycleTime.dialogTitle2')+scope.row['shift'+item].shiftSum+$t('StepCycleTime.dialogTitle3')">{{scope.row['shift'+item].shiftSum}}</span>
              </div>
            </div>
          </template>
        </el-table-column>
        
      </el-table>
      <div class="limtWrap">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" :inline='true' label-width="auto" class="demo-ruleForm">
          <el-form-item :label="$t('StepCycleTime.tableLable2')">
              <el-form-item prop="limt1" >
                <el-input type="number" style="width:100px;" @blur="valueLimt1" v-model="ruleForm.limt1"></el-input>
              </el-form-item>
              <span style="margin:0 10px">~</span>
              <el-form-item prop="limt2">
                <el-input type="number" style="width:100px;" @blur="valueLimt1" v-model="ruleForm.limt2"></el-input>
              </el-form-item>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t('StepCycleTime.dialogCancel')}}</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">{{$t('StepCycleTime.dialogOk')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import { formatDate } from '../assets/js/date.js'
import leftNav from "@/components/nav.vue"
import equipment from "@/components/Equipment.vue"
// import { Loading } from 'element-ui'

export default {
  name: 'ProductionRecord',
  components: {
    leftNav,
    equipment
  },
  data () {
    var validateLimt1 = (rule, value, callback) => {
      let reg = /^[+]{0,1}(\d+)$/;
      if (value === '') {
        callback(new Error(this.$t('StepCycleTime.error6')));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('StepCycleTime.error5')));
      } else if (value > 20000 && this.$store.state.newroute=='haiantyre') {
        this.ruleForm.limt1 = 20000
        callback()
      } else if (value > 1000 && this.$store.state.newroute!='haiantyre') {
        this.ruleForm.limt1 = 1000
        callback()
      } else{
        callback()
      }
    };
    var validateLimt2 = (rule, value, callback) => {
      let reg = /^[+]{0,1}(\d+)$/;
      if (value === '') {
        callback(new Error(this.$t('StepCycleTime.error7')));
      } else if (!reg.test(value)) {
        callback(new Error(this.$t('StepCycleTime.error5')));
      } else if (value > 20000 && this.$store.state.newroute=='haiantyre') {
        this.ruleForm.limt2 = 20000
        callback()
      } else if (value > 1000 && this.$store.state.newroute!='haiantyre') {
        this.ruleForm.limt2 = 1000
        callback()
      } else{
        callback()
      }
    };
    return {
      resizeTimer: null,
      //  模拟数据
      options: [],
      // 选中的机械id
      machineID: [],
      // 选择时间
      // 时间选择器左侧快捷按钮事件
      dateBtn1: '',
      dateBtn2: '',
      dateBtn3: '',
      dateBtn4: '',
      dateBtn5: '1',
      // 副标题开始时间和结束是案件
      showStartTime: '',
      showEndTime: '',
      // 所有班组最大值
      maxNum: '',
      machineData: {},
      fullscreenLoading: false,
      
      // 下拉选择框数据
      selectOptions: [],
      // 表格数据
      tableData:[],
      tableTitle:[],
      selectValue: [],
      // 弹出框
      dialogVisible: false,
      // 时间选择器逻辑
      shiftTime: '',
      pickerMinDate: '',
      pickerOptions: {
        shortcuts: [{
          text: this.$t('StepCycleTime.pickLable1'),
          onClick:(picker)=> {
            const end = new Date();
            const start = new Date();
            if (this.$store.state.shiftTime === '') {
              this.$message.error(this.$t('StepCycleTime.error1'));
            } else {
              start.setTime(this.$store.state.shiftTime[0].shiftStartTime);
              end.setTime(this.$store.state.shiftTime[0].shiftEndTime);
              this.$store.state.startPicker = formatDate(start, 'yyyy-MM-dd hh:mm:ss')
              this.$store.state.endPicker = formatDate(end, 'yyyy-MM-dd hh:mm:ss')
              this.$refs.dataWrap1.handleClose()
              this.$refs.dataWrap2.handleClose()
            }
          }
        }, {
          text: this.$t('StepCycleTime.pickLable2'),
          onClick:(picker)=> {
            const end = new Date();
            const start = new Date();
            if (this.$store.state.shiftTime === '') {
              this.$message.error(this.$t('StepCycleTime.error1'));
            } else {
              start.setTime(this.$store.state.shiftTime[1].shiftStartTime);
              end.setTime(this.$store.state.shiftTime[1].shiftEndTime);
              this.$store.state.startPicker = formatDate(start, 'yyyy-MM-dd hh:mm:ss')
              this.$store.state.endPicker = formatDate(end, 'yyyy-MM-dd hh:mm:ss')
              this.$refs.dataWrap1.handleClose()
              this.$refs.dataWrap2.handleClose()
            }
          }
        }, {
          text: this.$t('StepCycleTime.pickLable3'),
          onClick:(picker)=> {
            const end = new Date();
            const start = new Date();
            if (this.$store.state.shiftTime === '') {
              this.$message.error(this.$t('StepCycleTime.error1'));
            } else {
              start.setTime(this.$store.state.shiftTime[2].shiftStartTime);
              end.setTime(this.$store.state.shiftTime[2].shiftEndTime);
              this.$store.state.startPicker = formatDate(start, 'yyyy-MM-dd hh:mm:ss')
              this.$store.state.endPicker = formatDate(end, 'yyyy-MM-dd hh:mm:ss')
              this.$refs.dataWrap1.handleClose()
              this.$refs.dataWrap2.handleClose()
            }
          }
        }, {
          text: this.$t('StepCycleTime.pickLable4'),
          onClick:(picker)=> {
            const end = new Date();
            const start = new Date();
            if (this.$store.state.shiftTime === '') {
              this.$message.error(this.$t('StepCycleTime.error1'));
            } else {
              start.setTime(this.$store.state.shiftTime[3].shiftStartTime);
              end.setTime(this.$store.state.shiftTime[3].shiftEndTime);
              this.$store.state.startPicker = formatDate(start, 'yyyy-MM-dd hh:mm:ss')
              this.$store.state.endPicker = formatDate(end, 'yyyy-MM-dd hh:mm:ss')
              this.$refs.dataWrap1.handleClose()
              this.$refs.dataWrap2.handleClose()
            }
          }
        }, {
          text: this.$t('StepCycleTime.pickLable5'),
          onClick:(picker)=> {
            const end = new Date();
            const start = new Date();
            if (this.$store.state.shiftTime === '') {
              this.$message.error(this.$t('StepCycleTime.error1'));
            } else {
              start.setTime(this.$store.state.shiftTime[4].shiftStartTime);
              end.setTime(this.$store.state.shiftTime[4].shiftEndTime);
              this.$store.state.startPicker = formatDate(start, 'yyyy-MM-dd hh:mm:ss')
              this.$store.state.endPicker = formatDate(end, 'yyyy-MM-dd hh:mm:ss')
              this.$refs.dataWrap1.handleClose()
              this.$refs.dataWrap2.handleClose()
            }
          }
        },{
          text: this.$t('StepCycleTime.pickLable6'),
          onClick:(picker)=> {
            const end = new Date();
            const start = new Date();
            if (this.$store.state.shiftTime === '') {
              this.$message.error(this.$t('StepCycleTime.error1'));
            } else {
              start.setTime(this.$store.state.shiftTime[5].shiftStartTime);
              end.setTime(this.$store.state.shiftTime[5].shiftEndTime);
              this.$store.state.startPicker = formatDate(start, 'yyyy-MM-dd hh:mm:ss')
              this.$store.state.endPicker = formatDate(end, 'yyyy-MM-dd hh:mm:ss')
              this.$refs.dataWrap1.handleClose()
              this.$refs.dataWrap2.handleClose()
            }
          }
        }]

      },
      // 表单验证
      ruleForm:{
        limt1: '',
        limt2: ''
      },
      rules:{
        limt1: [
          { validator: validateLimt1, trigger: 'change' }
        ],
        limt2: [
          { validator: validateLimt2, trigger: 'change' }
        ]
      },
      // 图表筛选条件数组
      chartTitle: [],
      // 图表数据
      chartData:[],
      shiftArr:[],
      //查询图表数据为空
      noData:false,
      // 显示时间组件里的红色提示
      tipsOne:false,
      tipsTwo:false,
    }
  },
  computed: {
    islangChange () {
      return this.$store.state.lang
    }
  },
  watch: {
    islangChange (curval, oldval) {
      if (curval != oldval) {
        this.$parent.reload()
        this.reLoadStep()
      }
    }
  },
  mounted() {
    
    if (this.$store.state.reloadState === false) {
      this.$store.state.reloadState = true
      this.$parent.reload()
    }else{
      this.$store.commit('authority' , this.$route.path)
      this.machineID=this.$store.state.machineID 
      this.getManiceList()
    }
  },
  destroyed() {
    clearInterval(this.resizeTimer)
  },
  methods: {
    // 切换设备
    getchange(value){
      this.machineID[0]=Number(this.$store.state.defaultFactoryId)
      this.machineID[1]=value
      this.$store.state.machineID = this.machineID
      this.machineChange()
    },
    // 获取车间列表
    getManiceList() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectChooseManice',
        params:{
          language: _this.$store.state.lang
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          if(localStorage.getItem('isMarketAccount') === '1') {
            _this.$store.commit('marketAccount',res.data.options)
          }
          _this.options = res.data.options
        } else {
          _this.$message.error('Machine list loading failed')
        }
      })
    },
    // 如果有machine切换中英文重新获取下step
    reLoadStep(){
        this.$store.state.stepSelectLoading = true
        this.getStepList()
    },
    // 获取后台班次时间
    getShiftTime() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/selectLastFiveMachineShift',
        params:{
          machineId: _this.machineID[1],
          num: 2
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.fullscreenLoading = false
          let shiftTimeShortcuts=[]
          let timeList = res.data.list
          timeList.forEach(item=>{
            let shiftTimeItem={
              text: item.title,
              onClick:()=> {
                const end = new Date();
                const start = new Date();
                if (timeList === '') {
                  _this.$message.error(_this.$t('StepCycleTime.error1'));
                } else {
                  start.setTime(item.startTime);
                  end.setTime(item.endTime);
                  _this.$store.state.startPicker = formatDate(start, 'yyyy-MM-dd hh:mm:ss')
                  _this.$store.state.endPicker = formatDate(end, 'yyyy-MM-dd hh:mm:ss')
                  _this.$refs.dataWrap1.handleClose()
                  _this.$refs.dataWrap2.handleClose()
                }
              }
            }
            shiftTimeShortcuts.push(shiftTimeItem)
          })
          _this.pickerOptions.shortcuts=shiftTimeShortcuts
          // _this.$store.state.shiftTime = res.data.list
          // _this.$parent.reload()
        } else {
          _this.$message.error('ShiftTime list loading failed')
        }
      })
    },
    machineChange(){
      this.fullscreenLoading = true
      this.getShiftTime()
      this.$store.state.selectValue = []
      this.$store.state.startPicker = ''
      this.$store.state.endPicker = ''
    },
    // 获取step列表
    getStepList() {
      let _this = this
      let start = ''
      let end = ''
      if (this.$store.state.startPicker !=null) start=this.$store.state.startPicker
      if (this.$store.state.endPicker != null) end=this.$store.state.endPicker
      this.axios({
        method: 'get',
        url: '/url/selectMachineStepMsg',
        params:{
          machineId: _this.machineID[1],
          language: _this.$store.state.lang,
          startTime: start,
          endTime: end
        }
      }).then(function(res){
        if (res.data.success === 'true') {
          _this.$store.state.selectOptions = res.data.options
          _this.$store.state.stepSelectLoading = false
        } else {
          _this.$message.error('Step list loading failed')
          _this.$store.state.stepSelectLoading = false
        }
      })
    },
    // show（查询）按钮
    showBtn(){
      let id = this.machineID
      let step = this.$store.state.selectValue.length
      let startBol= this.$store.state.startPicker==''||this.$store.state.startPicker==null
      let endBol= this.$store.state.endPicker==''||this.$store.state.endPicker==null
      if (id.length === 0) {
        this.$message.error(this.$t('StepCycleTime.error1'));
      } else if (startBol || endBol) {
        this.$message.error(this.$t('StepCycleTime.error2'));
      } else if (step === 0){
        this.$message.error(this.$t('StepCycleTime.error3'));
      } else {
        this.fullscreenLoading = true
        this.getData()
      }
    },
    // 获取数据
    getData(){
      let _this = this
      let start = ''
      let end = ''
      if (this.$store.state.startPicker !=null) start=this.$store.state.startPicker
      if (this.$store.state.endPicker != null) end=this.$store.state.endPicker
      this.axios({
        method: 'POST',
        url: '/url/getStepCycleTimeData',
        params:{
          factoryId: _this.machineID[0],
          machineId: _this.machineID[1],
          stepCode: _this.$store.state.selectValue[1],
          startTime: start,
          endTime: end,
          language: _this.$store.state.lang,
          min: _this.ruleForm.limt1,
          max: _this.ruleForm.limt2
          
        }
      }).then(function(res){
        if ( res.data.success === 'true') {
          _this.noData=false
          _this.ruleForm.limt1 = res.data.min
          _this.ruleForm.limt2 = res.data.max
          _this.shiftArr = res.data.shiftNames
          _this.chartData= []
          let maxArr = []
          let shiftName=''
          for (const [index,item] of res.data.shiftNames.entries()) {
            shiftName = item
            _this.tableTitle[index] = item
            maxArr.push(Math.max.apply(null, res.data['shift'+item]))
            _this.chartTitle.push(_this.$t('StepCycleTime.shiftTitle')+' ' + shiftName)
            let randomColor = '#' + Math.random().toString(16).substr(2, 6).toUpperCase();
            let barObj = {
              name: _this.$t('StepCycleTime.shiftTitle') +' '+ shiftName,
              type:'bar',
              itemStyle: {
                  normal: {color: randomColor}
              },
              data:res.data['shift'+item]
            }
            let lineObj ={
              name: _this.$t('StepCycleTime.shiftTitle') +' '+shiftName,
              type:'line',
              itemStyle: {
                  normal: {color: randomColor}
              },
              yAxisIndex: 1,
              data:res.data['YID'+item]
            }
            _this.chartData.push(barObj,lineObj)
          }
          _this.maxNum = Math.max.apply(null, maxArr)
          _this.machineData = res.data
          _this.tableData = res.data.shiftList
          _this.showStartTime = _this.$store.state.startPicker.slice(0,-3)
          _this.showEndTime = _this.$store.state.endPicker.slice(0,-3)
          _this.fullscreenLoading = false
          _this.initChart()
        } else {
          if (_this.ganttChart) _this.ganttChart.clear()
          _this.noData=true
          _this.fullscreenLoading = false
          _this.$message.error(res.data.msg);
        }
      })
    },
    // 柱形图初始化
    initChart(){
      let _this = this
      this.ganttChart = this.$echarts.init(document.getElementById('StepCycleTimemyChart'))
      this.ganttChart.setOption({
        tooltip: {
          trigger: 'axis',
          formatter: function(params){
            let res = params[0].axisValue
            for (const item of params) {
              if (item.componentSubType==='line') {
                res = res + `<br/> ${item.marker} ${item.seriesName} : ${item.data} %`
              } else {
                res = res + `<br/> ${item.marker} ${item.seriesName} : ${item.data}`
              }
            }
            return res
          },
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          },
          backgroundColor: 'rgba(245, 245, 245, 0.8)',
          borderWidth: 1,
          borderColor: '#ccc',
          padding: 10,
          textStyle: {
              color: '#000'
          }
        },
        grid:{
          left: '6%', 
        },
        toolbox: {
          show: true,
          itemSize:30,
          feature: {
            myTool1:{
              title:' ',
                icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAMAAAB+ITwmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjhGQ0NEQUY0QkE5MTFFOTgwRkJGNUJCREY2OTM1MTIiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjhGQ0NEQUU0QkE5MTFFOTgwRkJGNUJCREY2OTM1MTIiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjBmNjIyOWI0LWJkNDItZGM0YS1iNDljLTIyZTFiYTgwNzZhYSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz6Fnr0hAAAANlBMVEX////h4eEoJibu7u5ZVVXd3d3j4+P8/PzMzMyysbH+/v52cnLz8/OPjY3q6upLSkrp6env7+9jECdJAAAAa0lEQVR42tyTyxKAIAhFMRAflen//2xa68DJFo13weoMnAUXIrIRwhgBswMhLhdgkagMgwElZgIkrNt7BGlpIQx17gOHLFlNV0Oay2H9JfTs8sGhO55w1EXb0o38/Os6qoZJLmwqoNf+FGAA8GAC4lmPVMIAAAAASUVORK5CYII=',
                option:{},
                onclick:function() {
                  _this.dialogVisible = true
                }
            },
            saveAsImage: {
              title:' ',
              icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAMAAAB+ITwmAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAA3FpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RUVGMkVDN0U0QkE5MTFFOUI1QjlEN0M3MTcwRDYwRUQiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RUVGMkVDN0Q0QkE5MTFFOUI1QjlEN0M3MTcwRDYwRUQiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjBmNjIyOWI0LWJkNDItZGM0YS1iNDljLTIyZTFiYTgwNzZhYSIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpiZTdmZjI2Zi1lYjY0LTdmNGMtYjRkYy04YTc5NTJhZjUzNTIiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7PlZeJAAAAM1BMVEX////h4eEoJib8/Pzj4+OysbHu7u75+flLSkr+/v5+fn7d3d3MzMzq6urp6env7++VlZXRcGIdAAAAZ0lEQVR42tyTSw6AIAwFH6WtogLe/7SaGDeghY2JOutJm34egrIzYA3Q5GHgUwabxu4wHBq4byvDRETyBmWlk+W2ihzCOBuNpDLqvUhpXKxOCuORA/QM/Yuv64iaRjuwMaMd+02AAQA9ewKBbQnBzgAAAABJRU5ErkJggg=='
            },
            myTool2:{
              show: _this.$store.state.authority.PageDownload.show,
              title:' ',
                icon: 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAeCAYAAABJ/8wUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo3OUE4Mzk1ODYwMTMxMUU5OTkwREUyNUEyNUFCODVGMyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo3OUE4Mzk1OTYwMTMxMUU5OTkwREUyNUEyNUFCODVGMyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjc5QTgzOTU2NjAxMzExRTk5OTBERTI1QTI1QUI4NUYzIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjc5QTgzOTU3NjAxMzExRTk5OTBERTI1QTI1QUI4NUYzIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+dmf26AAAAWpJREFUeNpivHfvHhsDA0M3EMcAsRADfcF7IF4MxKUsQKKLk5MzT1RUlIGZmZmurvj796/g69ev874DAROQHzsQjgABkJ0gu4EgFeQQoYFwBLJjQG5gYhgkgIUYRVdvPmZYvngmw+fPn/GqMzc3Z4iKiiLLIUSFCDGOAIGTJ08yLFu2jHYhAnPExIkTcarJz8+HOwYESA0ZmqQRckKGZomVVMfQNNeQ4hiaZ19YmqFKYiUGYEvIsAQ8KEJkyDmEoqjZuWMHw7bt28FsL09PBncPj6EfIkM7as6dO8ewcOFCFDFQFIEwuRUfWSFiZGTEEB8fT//alxjHUOIIinMNyDEgcOPGDYocQZWSFeQYmINo7hBeXl5wm4SUIhsG5OXkqJdGgoKCiDYQ3QMOjo7UCxFqBf+QKVnfAXtcA+YAqN3vQA5Z/ObNG4aBcMyfP38YQHYDwRxQGin79u0b46NHj2KBbMEB6oTXAgQYAEk/geeSh3YUAAAAAElFTkSuQmCC',
                option:{},
                onclick:function() {
                  let signTime = new Date().getTime()
                  _this.$store.commit('nowsign', signTime)
                  let urlData = '?machineId=' + _this.machineID[1] + '&stepCode=' + _this.$store.state.selectValue[1] + '&startTime=' + _this.$store.state.startPicker + '&endTime=' + _this.$store.state.endPicker + '&language='+ _this.$store.state.lang + '&min=' + _this.ruleForm.limt1 + '&max=' + _this.ruleForm.limt2 + '&sign='+_this.$store.state.sign + '&auth_Code='+_this.$store.state.authCode+'&sign_time='+signTime+'&route='+_this.$store.state.newroute+'&factory_id='+_this.$store.state.factoryId
                  window.open('/url/excelExportStepCycleTimeAnalysisData' + urlData, '_blank')
                  
                }
            }
          }
        },
        legend: {
          top: 'top',
          data: _this.chartTitle
        },
        xAxis: [
          {
            type: 'category',
            data: _this.machineData.xList,
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: _this.$t('StepCycleTime.tableLeftTitle'),
            nameGap: 10,
            max: _this.maxNum+10,
            min: 0,
            interval: 10,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            nameGap: 10,
            name: _this.$t('StepCycleTime.tableRightTitle'),
            max: 120,
            min: 0,
            interval: 20,
            splitLine:{
              show:false
            },
            axisLabel: {
              formatter: '{value} %'
            }
          }
        ],
        dataZoom: [
          {
            show: true,
            start: 0,
            end: 100
          },
          {
            type: 'inside',
            start: 94,
            end: 100
          },
          {
            show: true,
            yAxisIndex: 0,
            filterMode: 'empty',
            width: 20,
            height: '80%',
            showDataShadow: false,
            left: '95%'
          }
        ],
        series: _this.chartData
      })

      this.resizeTimer = setInterval(function(){
        _this.ganttChart.resize()
      },500)
    },
    // 两个选择器发生变化时候触发
    clearDis(){
      if(this.$store.state.startPicker==='') return
      if(this.$store.state.endPicker==='') return
      let start = new Date(this.$store.state.startPicker)
      let end = new Date(this.$store.state.endPicker)
      let result = end - start
      if(result<0){
        let saveStart= this.$store.state.startPicker
        let saveEnd = this.$store.state.endPicker
        this.$store.state.startPicker = saveEnd
        this.$store.state.endPicker = saveStart
        result = new Date(saveStart)-new Date(saveEnd)
      }
      if(result>168*60*60*1000){
        this.$message.error(this.$t('StepCycleTime.error8'));
        this.$store.state.startPicker=''
        this.$store.state.endPicker=''
        this.$store.state.selectValue = []
        return
      }
      this.$store.state.stepSelectLoading = true
      this.getStepList()
      this.$store.state.selectValue = []
      
    },
    // 修改上下线值
    valueLimt1(){
      if ( Number(this.ruleForm.limt1) > Number(this.ruleForm.limt2)) {
        this.ruleForm.limt2 = this.ruleForm.limt1
      }
    },
    // 提交修改
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.fullscreenLoading = true
          this.getData()
        } else {
          return false;
        }
      });
    },
    // 时间选择器聚焦
    getfocus(i){
      setTimeout(() => {
        if(i==1) this.tipsOne = true
        else this.tipsTwo = true
        let ele = document.getElementsByClassName("el-picker-panel__footer")
        for (const item of ele) {
          let son = item.getElementsByTagName('p')
          if(son.length==0){
            let p = document.createElement('p')
            p.innerHTML = this.$t('StepCycleTime.error8')
            p.setAttribute('style', `color: #000;display: inline-block;margin-left: 10px;font-size: 12px;float:left`)
            item.appendChild(p)
          }
        }
      }, 100);
    }
  }
}
</script>
<style scoped>
.StepCycleTime{
  min-width: 1365px!important;
}
.mainWrao{
  height: 100%;
  min-width: 100%;
  background-color: #f6f9fc;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
}
.recordTitle{
  padding: 20px 25px;
  background-color: #fff;
  border-bottom: 1px solid #e5e5e5;
  border-radius: 4px 4px 0 0;
  line-height: 35px;
}
.recordTitle h1{
  font-size: 20px;
  color: #525f7f;
  margin-bottom: 5px;
  display: inline-block;
}
.seach{
  padding: 15px 20px;
  position: relative;
}
.seach label{
  margin-right:10px;
  font-size: 14px!important;
}
#chartWrap .chartTitle{
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
#chartWrap .time{
  text-align: center;
  color: rgba(166, 166, 166, 1);
  font-size: 16px;
  margin: 5px 0;
}
.dialog-title p{
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: center;
}
.dialog-title span{
  font-size: 14px;
  font-weight: bold;
  color: rgba(166, 166, 166, 1)
}
.limtWrap{
  margin-top: 30px;
}
.dialog-footer{
  text-align: center;
}
.dialog-footer button{
  width: 100px;
}
.shiftTime{
  font-size: 12px;
}
.tireWrap{
  float: right;
  font-size: 12px
}
.tireWrap span{
  display: inline-block;
  line-height: 1!important;
  padding: 3px 5px;
  border-radius: 5px;
}
.tireWrap .left{
  color: #000;
  background-color: rgba(190, 194, 231, 1);
  border-radius: 5px 0 0 5px;
}
.tireWrap .right{
  color: #fff;
  background-color: rgba(99, 137, 195, 1)
}
.tireWrap span:nth-child(2){
  border-radius: 0 5px 5px 0;
}
.celldis .shiftTime{
  color:#ccc
}
.celldis .left{
  background-color: #eee
}
.celldis .right{
  background-color: #ccc
}
.noMachineTitle{
  color:#909399;
  line-height: 100px;
  text-align: center;
}
</style>

